import {Injectable} from '@angular/core';
import { Headers, Response, URLSearchParams, RequestOptions } from '@angular/http';
import {HttpAuth} from './http-auth.service';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import { Notification } from '../models/notification';
import 'rxjs/add/operator/map';

@Injectable()
export class NotificationService {

  private notificationUrl: string = `${ environment.apiRoot }/notification/`;

  constructor(private http: HttpAuth) { }

  public getNotifications(status?: string[], page?: number, pagecount?: number): Observable<any> {
    const params: URLSearchParams = new URLSearchParams();

    if (page != null) {
      params.append('page', String(page));
    } else {
      params.append('page', '1');
    }

    if (pagecount != null) {
      params.append('pagecount', String(pagecount));
    } else {
      params.append('pagecount', '10');
    }

    if(status){
      status.forEach(function(element, index, array) {
          params.append('status[]', element);
      });
  }

    const options = new RequestOptions({search: params});

    return this.http.get(this.notificationUrl, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  public readNotification(notification): Observable<any> {
    let params: URLSearchParams = new URLSearchParams();
    const body = notification;

    let options = new RequestOptions({search: params});

    return this.http.put(this.notificationUrl, body, options)
      .map(this.extractData)
      .catch(this.handleError);
  }

  //noinspection JSMethodCanBeStatic
  private extractData(res: Response) {
    let body = res.json();
    return body.data || {};
  }

  //noinspection JSMethodCanBeStatic
  private handleError(error: Response | any) {
    let errMsg: string;

    if (error instanceof Response) {
      const body = error.json() || '';
      const err = body.meta && body.meta.message || JSON.stringify(body);
      errMsg = `${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }

    console.error(errMsg);

    return Observable.throw(errMsg);
  }
}



// WEBPACK FOOTER //
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/services/notification.service.ts